// extracted by mini-css-extract-plugin
export default {"container":"ModalUp_container__A6dOl","icon":"ModalUp_icon__ZnllZ"};